import React from "react";
import Chart from "react-apexcharts";
import { Card, CardHeader, CardBody } from "reactstrap";

const RevenueSourcePie = ({ summary = {} }) => {
  const series = [
    summary.roomRevenue || 0,
    summary.foodRevenue || 0,
    summary.restaurantRevenue || 0,
    summary.spaRevenue || 0,
  ];

  const options = {
    chart: {
      type: "donut",
      toolbar: {
        show: false,
      },
    },

    labels: [
      "Rooms",
      "Food",
      "Restaurant",
      "Spa",
    ],

    colors: [
      "#3cd188",
      "#efae4e",
      "#4b7bec",
      "#f7666e",
    ],

    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      fontWeight: 500,
      fontSize: "13px",
    },

    dataLabels: {
      enabled: true,
    },

    stroke: {
      width: 2,
    },

    plotOptions: {
      pie: {
        expandOnClick: true,

        donut: {
          size: "68%",
        },
      },
    },

    tooltip: {
      y: {
        formatter: (value) =>
          `₹${Number(value).toLocaleString()}`,
      },
    },
  };

  return (
    <Card className="card-height-100">
      <CardHeader className="align-items-center d-flex">
        <h4 className="card-title mb-0 flex-grow-1">
          Revenue Sources
        </h4>
      </CardHeader>

      <CardBody>
        <Chart
          options={options}
          series={series}
          type="donut"
          height={360}
        />
      </CardBody>
    </Card>
  );
};

export default RevenueSourcePie;